import { Signal } from '@angular/core';

export abstract class DateSelectionService {
  abstract date: Signal<string>;
  abstract setDate(date: string): void;
}
